module.exports = __webpack_public_path__ + "static/media/take-it.ab47e181.svg";